import { StateType } from 'typesafe-actions';
import { RootState as SharedRootState } from 'shared/reducers';
import components from './components';

export default components;

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

export type RootState = Omit<StateType<SharedRootState>, 'components'> & {
  components: StateType<typeof components>;
};
